import { Link, useParams, Navigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Logo } from "@/components/Logo";
import { POSTS } from "./blogData";
import { fmtDate } from "@/lib/format";
import { Button } from "@/components/ui/button";

export default function BlogPost() {
  const { slug } = useParams();
  const post = POSTS.find((p) => p.slug === slug);
  if (!post) return <Navigate to="/blog" />;

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="sticky top-0 z-50 bg-slate-900/95 backdrop-blur-md text-white border-b border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
          <Link to="/"><Logo light /></Link>
          <Link to="/cadastro"><Button className="bg-sky-600 hover:bg-sky-500 text-white h-11" data-testid="post-cta-btn">Começar grátis</Button></Link>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-testid="blog-post">
        <Link to="/blog" className="inline-flex items-center gap-1 text-sm text-slate-500 hover:text-slate-800" data-testid="back-blog">
          <ArrowLeft className="h-4 w-4" /> Blog
        </Link>
        <p className="mt-6 text-xs text-slate-400 font-mono-num">{fmtDate(post.date)}</p>
        <h1 className="mt-2 text-3xl sm:text-4xl font-extrabold tracking-tight">{post.title}</h1>
        <div className="mt-8 space-y-5">
          {post.content.map((p, i) => (
            <p key={i} className="text-slate-700 leading-relaxed">{p}</p>
          ))}
        </div>
        <div className="mt-12 bg-slate-900 text-white rounded-xl p-8 text-center">
          <h2 className="text-xl font-bold">Calcule seu próximo serviço em 2 minutos</h2>
          <p className="mt-2 text-slate-300 text-sm">Custo, margem e orçamento profissional em PDF. Grátis para começar.</p>
          <Link to="/cadastro"><Button className="mt-5 h-12 px-8 bg-sky-600 hover:bg-sky-500 text-white" data-testid="post-bottom-cta">Criar conta grátis</Button></Link>
        </div>
      </main>
    </div>
  );
}
